module.exports = __webpack_public_path__ + "img/logo.7823aca3.png";